import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, watchEffect, ref } from 'vue'
import type { Booking } from '@/models/your-bookings'


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleMap',
  props: {
    booking: null
  },
  setup(__props: any) {

const props = __props as {
  booking: Booking;
};



const mapDiv = ref<HTMLDivElement>()

let map: google.maps.Map | null = null
const pickupMarker = new google.maps.Marker({
})
const destinationMarker = new google.maps.Marker({
})
const driverMarker = new google.maps.Marker({
  icon: require('@/assets/img/icons8-car-48.png'),
})

const updateMap = () => {
  if (!map) {
    return
  }

  const booking = props.booking

  const markerBounds = new google.maps.LatLngBounds()
  let pickupLatLng
  let destinLatLng
  let driverLatLng

  if (booking.pickupLat && booking.pickupLng) {
    pickupLatLng = { lat: booking.pickupLat, lng: booking.pickupLng }
    pickupMarker.setPosition(pickupLatLng)
    markerBounds.extend(pickupLatLng)

    pickupMarker.setMap(map)
  } else {
    pickupMarker.setMap(null)
  }

  if (booking.destinationLat && booking.destinationLng) {
    destinLatLng = { lat: booking.destinationLat, lng: booking.destinationLng }
    destinationMarker.setPosition(destinLatLng)
    markerBounds.extend(destinLatLng)

    destinationMarker.setMap(map)
  } else {
    destinationMarker.setMap(null)
  }

  const driver = booking.driverVehicle?.driver
  if (booking.isVehicleLocationViewable) {
    if (driver?.positionLat && driver?.positionLng) {
      driverLatLng = { lat: driver.positionLat, lng: driver.positionLng }
      driverMarker.setPosition(driverLatLng)
      markerBounds.extend(driverLatLng)
  
      driverMarker.setMap(map)
    } else {
      driverMarker.setMap(null)
    }
  }

  if (pickupLatLng && destinLatLng) {
    map.fitBounds(markerBounds)
  }
}

const createMap = () => {
  if (!mapDiv.value) {
    return;
  }

  const center: google.maps.LatLngLiteral = { lat: 53.3289963, lng: -6.3782051 }
  map = new google.maps.Map(mapDiv.value, {
    center,
    zoom: 8,
    fullscreenControl: true,
  })

  watchEffect(updateMap)
}


onMounted(createMap)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "booking-details-map",
    ref_key: "mapDiv",
    ref: mapDiv
  }, null, 512))
}
}

})